import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import PulseLoader from 'react-spinners/PulseLoader'

interface FullscreenLoaderProps {
  message?: string
  isActive?: boolean
}

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(12, 35, 64, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

const Message = styled.div`
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0 5px 5px rgba(0, 0, 0, 0.05);
  text-align: center;
`

export const FullscreenLoader: React.FC<FullscreenLoaderProps> = ({ message, isActive = true }) => {
  useEffect(() => {
    if (isActive) {
      // Remove scroll
      const originalOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'

      // Cleanup: Restaura scroll quando desmontar ou desativar
      return () => {
        document.body.style.overflow = originalOverflow
      }
    }
  }, [isActive])

  if (!isActive) {
    return null
  }

  return createPortal(
    <OverlayContainer>
      <ContentWrapper>
        <PulseLoader color='#ffffff' size={15} margin={2} />
        {message && <Message>{message}</Message>}
      </ContentWrapper>
    </OverlayContainer>,
    document.body,
  )
}
